import React from 'react'
import {possibleAttributes} from './importModel'
import { Divider, Radio, Space } from 'antd'
import { Switch } from '../Wrappers'

const options = [
  { label: 'Name', value: 'name' },
  { label: 'Sku', value: 'sku' },
  { label: 'Both', value: 'both' },
];

export default function ImportModifiers({ data, selectedAttributes: initialAttributes = [], updateImportModifiers }) {
  let defaultImportType = 'name'
  if (data && data.length > 0 && !data[0].name && data[0].sku) {
    defaultImportType = 'sku'
  }

  const [importType, setImportType] = React.useState(defaultImportType);
  const [selectedAttributes, setSelectedAttributes] = React.useState(initialAttributes);

  const importTypeChange = e => {
    setImportType(e.target.value)
    setInputModifiers(e.target.value, addTypeToAttributes(e.target.value, selectedAttributes))
  };

  const selectedAttributesChange = attributes => {
    setSelectedAttributes(attributes)
    setInputModifiers(importType, addTypeToAttributes(importType, attributes))
  }

  const addTypeToAttributes = (type, attributes) => {
    // select IS broken... for the unique corner case of transpilation that we're doing
    // [...Set(array)] was always returning empty, so Array.from is necessary
    const uniqueArray = (array) => [...Array.from(new Set(array))]
    return uniqueArray(['name', 'sku', ...attributes])
  }

  const setInputModifiers = (type, attributes) => {
    if (updateImportModifiers) {
      updateImportModifiers({
        type,
        attributes,
      })
    }
  }

  let matchOn = <></>
  if (data && data.length > 0) {
    if (data[0].name && data[0].sku) {
      matchOn =
        <>
          <Space direction="vertical">
            Match on
            <Radio.Group
              options={options}
              onChange={importTypeChange}
              value={importType}
              optionType="button"
              buttonStyle="solid"
            />
          </Space>
          <Divider />
        </>
    }
  }

  let attributes = []
  if (data && data.length > 0) {
    attributes = possibleAttributes.filter(attribute => {
      return data[0][attribute.value] !== undefined
    })
  }

  return <>
    {matchOn}
    <Space direction="vertical">
      Please select one or more attributes to import
      <Switch.Group
        onChange={selectedAttributesChange}
        options={attributes}
        value={selectedAttributes}
        selectAll={true}
      />
    </Space>
  </>
}